import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { Form, FormCreateRequest, FormPreset } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const formApi = {
	index: (workspaceId: string): Promise<AxiosResult<any>> => {
		return axiosRequest({
			method: "GET",
			url: `${API_BASE_URL}/${workspaceId}/forms`,
		});
	},

	show: (id: string, workspaceId: string): Promise<AxiosResult<Form>> => {
		return axiosRequest({
			method: "GET",
			url: `${API_BASE_URL}/${workspaceId}/forms/${id}`,
		});
	},

	create: (workspaceId: string, payload: FormCreateRequest): Promise<AxiosResult<Form>> => {
		return axiosRequest({
			method: "POST",
			url: `${API_BASE_URL}/${workspaceId}/forms`,
			data: payload,
		});
	},

	update: (id: string, workspaceId: string, payload: Partial<FormCreateRequest>): Promise<AxiosResult<Form>> => {
		return axiosRequest({
			method: "PATCH",
			url: `${API_BASE_URL}/${workspaceId}/forms/${id}`,
			data: payload,
		});
	},

	delete: (id: string, workspaceId: string): Promise<AxiosResult<void>> => {
		return axiosRequest({
			method: "DELETE",
			url: `${API_BASE_URL}/${workspaceId}/forms/${id}`,
		});
	},

	clone: (id: string, workspaceId: string): Promise<AxiosResult<Form>> => {
		return axiosRequest({
			method: "POST",
			url: `${API_BASE_URL}/${workspaceId}/forms/${id}/clone`,
		});
	},

	listPresets: (): Promise<AxiosResult<FormPreset[]>> => {
		return axiosRequest({
			method: "GET",
			url: `${API_BASE_URL}/form-presets`,
		});
	},
};
